import { Component, OnInit, Input } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { Clipboard } from '@capacitor/clipboard';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-comment-actions-menu',
  templateUrl: './comment-actions-menu.component.html',
  styleUrls: ['./comment-actions-menu.component.scss'],
})
export class CommentActionsMenuComponent implements OnInit {
  @Input() comment: any;
  @Input() isCurrentUserComment: boolean;
  @Input() isMaxNestingLevel: boolean = false;

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController
  ) {}

  ngOnInit() {
    this.comment = this.navParams.get('comment');
    this.isCurrentUserComment = this.navParams.get('isCurrentUserComment');
  }

  async react(reactionType: string) {
    await this.popoverCtrl.dismiss({
      action: 'react',
      reactionType: reactionType,
      comment: this.comment,
    });
  }

  async reply() {
    await this.popoverCtrl.dismiss({ action: 'reply', comment: this.comment });
  }

  async threadReply() {
    await this.popoverCtrl.dismiss({
      action: 'threadReply',
      comment: this.comment,
    });
  }

  async copyMessage() {
    await Clipboard.write({
      string: this.comment.text,
    });

    const toast = await this.toastCtrl.create({
      message: 'Comment copied to clipboard',
      duration: 2000,
      position: 'bottom',
    });
    await toast.present();

    await this.popoverCtrl.dismiss({ action: 'copy', comment: this.comment });
  }

  async editMessage() {
    await this.popoverCtrl.dismiss({ action: 'edit', comment: this.comment });
  }

  async deleteMessage() {
    await this.popoverCtrl.dismiss({ action: 'delete', comment: this.comment });
  }

  async flagMessage() {
    await this.popoverCtrl.dismiss({ action: 'flag', comment: this.comment });
  }
}

